// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"254":"25876feac9f8e567ae44","915":"eb2a7d0db99335e6a4fa"}[chunkId] + ".chunk.js";
};